<ng-container
  *ngIf="{
    cartRequest: cartRequest$ | async,
  } as content"
>
  @if (!content.cartRequest?.isPristine) {
    @if (!content.cartRequest?.isLoading) {
      <div class="box-empty text-center">
        <h2 class="m-b-20">{{ 'cart.cartEmpty.yourShoppingCartIsEmpty' | cxTranslate }}</h2>
        <div class="d-flex justify-content-center w-100">
          <a routerLink="/c/root" class="btn btn-primary">{{ 'cart.cartEmpty.continueShopping' | cxTranslate }}</a>
        </div>
      </div>
    } @else {
      <local-loader></local-loader>
    }
  }
</ng-container>